import React from "react";
import { Page, View, Text, StyleSheet, Image, Font } from "@react-pdf/renderer";

// Register Roboto font
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});
Font.registerHyphenationCallback(word => [word]);
// Styles
const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontFamily: "Roboto",
    position: "relative",
    paddingTop: 110,
    paddingBottom: 110,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -20,
    right: 0,
    width: 280,
    marginBottom: 80,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -20,
    right: 0,
    width: 300,
    marginTop: "20px",
  },
  mainContent: {
    flex: 1,
    alignContent: "center",
    paddingHorizontal: 40,
  },
  heading: {
    fontSize: 23,
    fontWeight: "bold",
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    paddingBottom: 20,
    width: "100%",
  },
  subheading: {
    fontSize: 19,
    marginBottom: 20,
  },
  listItem: {
    // marginBottom: 15,
    marginLeft: 12,
    flexDirection: "row",
  },
  listText: {
    flex: 1,
    fontSize: 17,
    lineHeight: 1.4,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});

const  ExplorationRecommendationsPDF = ({ recommendations, assets,showPageNumber }) => (
  <Page size="A4" style={styles.page}>
    {/* Design elements */}
    <Image src={assets.upper} style={styles.upperDesign} fixed />
    <Image src={assets.lower} style={styles.lowerDesign} fixed />
    <Image src={assets.logo2} style={styles.logo2} fixed />

    {/* Main content */}
    <View style={styles.mainContent}>
      <Text style={styles.heading}>How You Can Start Exploring Right Now</Text>

      {recommendations?.map((item, idx) => (
        <View key={idx} style={styles.listItem}>
          <Text style={styles.bulletPoint}>
            •{" "}
            <Text style={styles.listText}>
              <Text style={{ fontWeight: "bold" }}>{item.title}:</Text>{" "}
              {item.description}
            </Text>
          </Text>
        </View>
      ))}
    </View>

    {/* Footer - page number only */}
    <>
      {showPageNumber && (
        <View style={styles.pageNumber_Box} fixed>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) => `${pageNumber}`}
            fixed
          />
        </View>
      )}
    </>
  </Page>
);

export default ExplorationRecommendationsPDF;
